export default __webpack_public_path__ + "static/media/about_background.02fff46f.jpg";